import AppConfig from '../../../appConfig';

const REACT_APP_CAD_CONSUMER_URL = AppConfig.envConfig
  ? `https://${AppConfig.envConfig.REACT_APP_CAD_CONSUMER_URL}`
  : '';

const REACT_APP_CAD_CONSUMER_URL_HEP = AppConfig.envConfig
  ? `https://${AppConfig.envConfig.REACT_APP_CAD_CONSUMER_URL_HEP}`
  : '';

const REACT_APP_CAD_CONSUMER_URL_PROFILER = AppConfig.envConfig
  ? `https://${AppConfig.envConfig.REACT_APP_CAD_CONSUMER_URL_PROFILER}`
  : '';

const REACT_APP_CAD_CONSUMER_URL_SIGNATURE = AppConfig.envConfig
  ? `https://${AppConfig.envConfig.REACT_APP_CAD_CONSUMER_URL_SIGNATURE}`
  : '';

const REACT_APP_CAD_BUY_VOUCHERS = AppConfig.envConfig?.REACT_APP_CAD_BUY_VOUCHERS
  ? `https://${AppConfig.envConfig.REACT_APP_CAD_BUY_VOUCHERS}`
  : 'https://philipsservicevouchers.woohoo.in/en-gb/heart-health/philips-ghs-heart-energy-reserve-e-gift-card';

const REACT_APP_CAD_URL = AppConfig.envConfig?.REACT_APP_CAD_URL
  ? `https://${AppConfig.envConfig.REACT_APP_CAD_URL}`
  : 'https://www.heartprint.philips.co.in/';

const REACT_ELASTIC_APM_URL = AppConfig.envConfig?.REACT_ELASTIC_APM_URL
  ? `https://${AppConfig.envConfig.REACT_ELASTIC_APM_URL}`
  : 'https://www.heartprint.philips.co.in/apm';

const ELASTIC_APM_ENVIRONMENT = AppConfig.envConfig?.ELASTIC_APM_ENVIRONMENT
  ? `ELASTIC_APM_ENVIRONMENT`
  : 'prod';
export {
  REACT_APP_CAD_CONSUMER_URL,
  REACT_APP_CAD_CONSUMER_URL_HEP,
  REACT_APP_CAD_CONSUMER_URL_PROFILER,
  REACT_APP_CAD_CONSUMER_URL_SIGNATURE,
  REACT_APP_CAD_BUY_VOUCHERS,
  REACT_APP_CAD_URL,
  REACT_ELASTIC_APM_URL,
  ELASTIC_APM_ENVIRONMENT,
};